import React from 'react';
import { Box, IconButton, Typography } from '@material-ui/core';
import { Add, Remove } from '@material-ui/icons';

export const PassengerTypeComponent = props => {
  const { id, passengers, setFieldValue, label } = props;
  const currentPassengerType = passengers.find(
    passengerType => passengerType.passenger_type_id === id
  );
  const limitDecrementPassenger = () => {
    const { mandatory, quantity } = currentPassengerType;
    let passengerQuantity;
    if (mandatory && quantity === 1) {
      passengerQuantity = 1;
      return 1;
    } else if (!mandatory && quantity === 0) {
      passengerQuantity = 0;
    } else {
      passengerQuantity = quantity - 1;
    }
    return passengerQuantity;
  };
  const incrementPassenger = () => {
    const newPassengers = [...passengers];
    const passengerTypeIndex = passengers.findIndex(
      passengerType => passengerType.passenger_type_id === id
    );
    newPassengers[passengerTypeIndex] = {
      ...currentPassengerType,
      quantity: currentPassengerType.quantity + 1,
    };
    setFieldValue('passengers', newPassengers);
  };
  const decrementPassenger = () => {
    const newPassengers = [...passengers];
    const passengerTypeIndex = passengers.findIndex(
      passengerType => passengerType.passenger_type_id === id
    );
    newPassengers[passengerTypeIndex] = {
      ...currentPassengerType,
      quantity: limitDecrementPassenger(),
    };
    setFieldValue('passengers', newPassengers);
  };
  return (
    <div>
      <Box display="inline" mr={2}>
        <IconButton color="secondary" onClick={decrementPassenger}>
          <Remove />
        </IconButton>
      </Box>
      <Typography display="inline">
        {currentPassengerType.quantity} {label}
      </Typography>
      <Box display="inline" ml={2}>
        <IconButton color="secondary" onClick={incrementPassenger}>
          <Add />
        </IconButton>
      </Box>
    </div>
  );
};

export default PassengerTypeComponent;
